export default __webpack_public_path__ + "static/media/percent.2d396e20.svg";